import { render, staticRenderFns } from "./VersionHistoryForm.vue?vue&type=template&id=25b579e0&scoped=true"
import script from "./VersionHistoryForm.vue?vue&type=script&lang=js"
export * from "./VersionHistoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b579e0",
  null
  
)

export default component.exports